/**
 * @file: useCreateOrder.ts
 * @copyright: (c) 2019-2026 sichuan zhichetech co., ltd.
 *
 * The "create an order" entry point, shared by the two affordances that offer
 * it: the bottom tab bar's center button (phone layouts) and the floating
 * button (wider shells, where there is no tab bar). Enforces the store's
 * create-order role restriction before opening the order flow.
 */

import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { OrgUserRoleHelper } from '@euler/functions/OrgUserRoleHelper';
import { useStoreConfiguration } from '@euler/functions/useStoreConfiguration';
import { useCurrentUserRole } from '@euler/functions/user/useCurrentUserRole';
import { useAlert } from '@euler/functions/ux/useAlert';
import { SafeHaptics, delayed } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';

export const useCreateOrder = () => {
  const navigation = useAppNavigation();
  const alert = useAlert();
  const role = useCurrentUserRole();
  const storeConfiguration = useStoreConfiguration();

  return usePersistFn(() => {
    SafeHaptics.impact();
    const restrictedRoles = storeConfiguration.restrictedRolesForCreateOrder;
    if (
      restrictedRoles?.length &&
      !new OrgUserRoleHelper(role).matchesAny(restrictedRoles)
    ) {
      void alert({ title: '对不起，您当前没有权限创建订单!' });
      return;
    }
    navigation.navigate('_order', {
      mode: 'new',
      type: 'main',
      onNavigateToExistingTask: (taskNo: string) => {
        delayed(() => {
          navigation.navigate('Task', { taskNo });
        }, 350);
      },
    });
  });
};
